import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import config from 'config'
function initializeSentry() {
	// If GIT_COMMIT is not present this is not a build and we
	// don't want sentry to execute so we don't get wrong metrics from local development
	if (
		typeof(GIT_COMMIT) !== 'undefined'
	) {
		Sentry.init({
			environment: config.environmentName,
			dsn: config.sentry.dsn,
			integrations: [
				new Integrations.BrowserTracing(),
			],
			tracesSampleRate: 0.05,
			release: GIT_COMMIT,
			normalizeDepth: 10,
			ignoreErrors: [
				'Cannot read property \'parentNode\' of null',
				'Extension context invalidated',
				'couldnt load facebook library',
				'Non-Error promise rejection captured with',
				'ResizeObserver loop limit exceeded',
			],
		})
	}
}

initializeSentry()
